var map = {
	"./ft_web_stitch_base01_.png": 699720,
	"./ft_web_stitch_base01_blk.png": 558135,
	"./ft_web_stitch_base01_blu.png": 581289,
	"./ft_web_stitch_base01_cml.png": 939214,
	"./ft_web_stitch_base01_crk.png": 439860,
	"./ft_web_stitch_base01_grn.png": 703109,
	"./ft_web_stitch_base01_lgd.png": 618791,
	"./ft_web_stitch_base01_lsl.png": 123187,
	"./ft_web_stitch_base01_nvy.png": 582955,
	"./ft_web_stitch_base01_orn.png": 466445,
	"./ft_web_stitch_base01_pnk.png": 963471,
	"./ft_web_stitch_base01_ppl.png": 262430,
	"./ft_web_stitch_base01_red.png": 41923,
	"./ft_web_stitch_base01_sax.png": 400446,
	"./ft_web_stitch_base01_wht.png": 854745,
	"./ft_web_stitch_base01_ylw.png": 222256
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 487605;